import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelDynamic as _vModelDynamic, withKeys as _withKeys, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b361e2f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "btn-group mxa-input-form" }
const _hoisted_2 = ["type", "maxlength", "placeholder", "aria-label", "autofocus", "autocomplete", "inputmode", "onKeyup"]
const _hoisted_3 = ["type", "maxlength", "placeholder", "aria-label", "autofocus", "autocomplete", "inputmode", "onKeyup"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-times",
  "data-test": "clear_button"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

import { computed } from 'vue'
import BaseButton from '@/components/common/button/BaseButton.vue'
import * as log from '@/model/util/log/Logger'
import { toInputType } from './inputType'
import { BUTTON_INPUTMODE } from '../button/buttonType'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseInput',
  props: {
  // type
  type: {
    type: String,
    default: 'text',
  },
  // データ
  modelValue: {
    type: String,
    default: '',
  },
  // placeholder
  placeholder: {
    type: String,
    default: undefined,
  },
  // 最大サイズ
  maxlength: {
    type: Number,
    default: undefined,
  },
  // autofocus属性
  autofocus: {
    type: Boolean,
    default: undefined,
  },
  // autocomplete属性
  autocomplete: {
    type: String,
    default: undefined,
  },
  // inputmode属性 html5.2で廃止されたがHTML Living Standardで復活した
  inputmode: {
    type: String,
    default: undefined,
  },
  // 追加スタイル
  styles: {
    type: String,
    default: undefined,
  },
  // 追加領域スタイル
  stylesParent: {
    type: String,
    default: undefined,
  },
  // クリアボタン
  clearButton: {
    type: Boolean,
    default: false,
  },
  // 検索ボタン
  searchButton: {
    type: Boolean,
    default: false,
  },
  // 検索ボタンのローディング表示有無
  searchButtonLoading: {
    type: Boolean,
    default: false,
  },
  // 検索ボタンの非活性有無
  searchButtonIsDisabled: {
    type: Boolean,
    default: false,
  },
  // 初期状態のフォーカス
  initFocus: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue", "search-click", "input-enter"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: string): void
  (e: 'search-click'): void
  (e: 'input-enter'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

log.trace(`BaseInput setup start.`)
// プロパティ定義

// Emit定義

// class属性付与
const classval = () => {
  // stylesの設定でclassを上書きする
  // 親コンポーネントからの追加指定をできないようにする
  if (props.styles === undefined) {
    return 'form-control mxa-input-text'
  }
  // return props.styles
  return `form-control mxa-input-text ${props.styles}`
}

/**
 * inputmodeの取得
 */
const inputmode = toInputType(props.inputmode)

/**
 * テキストデータ算出プロパティ
 */
const textValue = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
})

/**
 * クリアボタンクリックイベント
 */
const onClearClick = () => {
  textValue.value = ''
}

/**
 * 検索ボタンクリックイベント
 */
const onSearchClick = () => {
  emit('search-click')
}

/**
 * 入力ボックスenter押下イベント
 */
const onEnter = () => {
  log.trace(`BaseInput onEnter start.`)
  emit('input-enter')
  log.trace(`BaseInput onEnter end.`)
}

log.trace(`BaseInput setup end.`)

return (_ctx: any,_cache: any) => {
  const _directive_focus = _resolveDirective("focus")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["input-group flex-nowrap", props.stylesParent]),
    "data-test": "input_parent"
  }, [
    _createElementVNode("div", _hoisted_1, [
      (props.initFocus)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 0,
            type: props.type,
            maxlength: props.maxlength,
            class: _normalizeClass(classval()),
            placeholder: props.placeholder,
            "aria-label": props.placeholder,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(textValue) ? (textValue).value = $event : null)),
            autofocus: props.autofocus,
            autocomplete: props.autocomplete,
            inputmode: _unref(inputmode),
            onKeyup: _withKeys(onEnter, ["enter"]),
            "data-test": "focus-yes"
          }, null, 42, _hoisted_2)), [
            [_vModelDynamic, _unref(textValue)],
            [_directive_focus]
          ])
        : _createCommentVNode("", true),
      (!props.initFocus)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            type: props.type,
            maxlength: props.maxlength,
            class: _normalizeClass(classval()),
            placeholder: props.placeholder,
            "aria-label": props.placeholder,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(textValue) ? (textValue).value = $event : null)),
            autofocus: props.autofocus,
            autocomplete: props.autocomplete,
            inputmode: _unref(inputmode),
            onKeyup: _withKeys(onEnter, ["enter"]),
            "data-test": "focus-no"
          }, null, 42, _hoisted_3)), [
            [_vModelDynamic, _unref(textValue)]
          ])
        : _createCommentVNode("", true),
      (props.clearButton)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "mxa-input-clear",
            onClick: onClearClick,
            "data-test": "clear_button_div"
          }, _hoisted_5))
        : _createCommentVNode("", true)
    ]),
    (props.searchButton)
      ? (_openBlock(), _createBlock(BaseButton, {
          key: 0,
          type: _unref(BUTTON_INPUTMODE).SUBMIT,
          loading: props.searchButtonLoading,
          "is-disabled": props.searchButtonIsDisabled,
          icon: true,
          onButtonClick: onSearchClick,
          "data-test": "search_button"
        }, null, 8, ["type", "loading", "is-disabled"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})